import { render, staticRenderFns } from "./Suspend.vue?vue&type=template&id=7679f654&scoped=true&"
import script from "./Suspend.vue?vue&type=script&lang=js&"
export * from "./Suspend.vue?vue&type=script&lang=js&"
import style0 from "./Suspend.vue?vue&type=style&index=0&id=7679f654&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7679f654",
  null
  
)

export default component.exports